export const CURRENCIES_RESPONSE_MOCK = {
  count: 3,
  next: null,
  previous: null,
  results: [
    {
      id: 3,
      network: 137,
      name: 'USDC',
      symbol: 'USDC',
      address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
      decimal: 6,
    },
    {
      id: 6,
      network: 137,
      name: 'RMV',
      symbol: 'RMV',
      address: '0xf0949Dd87D2531D665010d6274F06a357669457a',
      decimal: 18,
    },
    {
      id: 9,
      network: 137,
      name: 'DONUT TRUMPET',
      symbol: 'TRUMPET',
      address: '0xd026A38A117E8B20a6E6F6D3A5C320BE977519c1',
      decimal: 18,
    },
  ],
};

